import {
  QBox,
  QFormControl,
  QSelect,
  QSelectItem,
  useCurrentUser,
} from '@qualio/ui-components';
import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ALL_DOCS_FILTER } from '../../TrainingFilter';
import { trainingFilterLabelKeys } from '../constants';

export const TrainingFilter = () => {
  const { t } = useTranslation();
  const currentUser = useCurrentUser();

  const trainingOptions: readonly QSelectItem[] = useMemo(
    () =>
      Object.entries(trainingFilterLabelKeys).map(([value, labelKey]) => ({
        value,
        label: t(labelKey),
      })),
    [t],
  );

  if (currentUser.permissions.can_view_workspace) {
    return null;
  }

  return (
    <QFormControl label={t('labels.filterBy')}>
      <Controller
        name="filter_by"
        render={({ field: { onChange, value, ...field } }) => (
          <QBox data-cy="library-training-filter">
            <QSelect
              {...field}
              options={trainingOptions}
              value={value ?? ALL_DOCS_FILTER}
              onChange={(item) => onChange(item?.value ?? null)}
              isClearable={false}
              aria-label={t('accessibilityLabels.trainingFilterAriaLabel')}
            />
          </QBox>
        )}
      />
    </QFormControl>
  );
};
